// @ts-nocheck
/* eslint-disable */
export const stdSortDownIcon = {
    data: `<?xml version="1.0" encoding="UTF-8"?><svg stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor"><path d="M14 10H2M10 14H2M6 18H2M18 6H2M19 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'sort-down' as const
};